import React, { FC, useState } from 'react';
import './assets/main.css';
import './assets/res.css';
import { mockPersons } from './utils';
import Accordion from './components/Accordion';
import Persons from './components/Persons';
import Stage2 from './components/Stage2';
import Stage3 from './components/Stage3';

const App: FC = () => {
  const [expanded, setExpanded] = useState<false | number>(0);
  const [persons, setPersons] = useState([...mockPersons]);
  const [coversPage, setCoversPage] = useState(0);

  const handleQuestionClick = (index: number) => {
    setExpanded(1);
    setCoversPage(index);
  };
  return (
    <div className="container">
      <div className="h-screen select-none ">

        <div className="top">
          <div className="main_title">
            <h1>מחשבון ביטוח בריאות</h1>
            <span>מלאו את הפרטים וקבלו הצעת מחיר משתלמת</span>
          </div>
          <div className="logo">
            <a href="https://www.protect-ins.co.il/" title="Protect | סוכנות ביטוח ופיננסים">
              <img src="assets/logo.png" alt="Protect | סוכנות ביטוח ופיננסים"/>
            </a>
          </div>
        </div>
        <Accordion
          i={0}
          expanded={expanded}
          setExpanded={setExpanded}
          title={'בחירת מבוטחים'}
        >
          <Persons onChange={setPersons} persons={persons} />
        </Accordion>
        <Accordion
          i={1}
          expanded={expanded}
          setExpanded={setExpanded}
          title={'בחירת כיסויים'}
        >
          <Stage2
            persons={persons}
            page={coversPage}
            onPageChange={setCoversPage}
            onPersonClick={setPersons}
          />
        </Accordion>
        <Accordion
          i={2}
          expanded={expanded}
          setExpanded={setExpanded}
          title="סיכום הצעת מחיר"
        >
          <Stage3
            persons={persons}
            onPersonChange={setPersons}
            onQuestionClick={handleQuestionClick}
          />
        </Accordion>
        <div className="fotter">
          <div className="links">
            <a href="/cal/assets/גילוי נאות - השתלות וטיפולים מיוחדים בחול.pdf" target="blank">גילוי נאות - השתלות וטיפולים מיוחדים בחול</a>
            <a href="/cal/assets/גילוי נאות - כיסוי לניתוחים ולטיפולים מחליפי ניתוח בישראל מהשקל הראשון.pdf" target="blank">גילוי נאות - כיסוי לניתוחים ולטיפולים מחליפי ניתוח בישראל מהשקל הראשון</a>
            <a href="/cal/assets/גילוי נאות - תרופות מיוחדות.pdf" target="blank">גילוי נאות - תרופות מיוחדות</a>
            <a href="/cal/assets/גילוי נאות לנספח ההרחבה - ניתוחים פרטיים בחול.pdf" target="blank">גילוי נאות לנספח ההרחבה - ניתוחים פרטיים בחול</a>
            <a href="/cal/assets/גילוי נאות לנספח ההרחבה - שירותים רפואיים אמבולטוריים וטכנולוגיות מתקדמות.pdf" target="blank">גילוי נאות לנספח ההרחבה - שירותים רפואיים אמבולטוריים וטכנולוגיות מתקדמות</a>
            <a href="/cal/assets/גילוי נאות לנספח ההרחבה - תרופות פרימיום.pdf" target="blank">גילוי נאות לנספח ההרחבה - תרופות פרימיום</a>
            <a href="/cal/assets/תקציר כתב השירות - מרכז פרטי לאבחון רפואי מהיר.pdf" target="blank">תקציר כתב השירות - מרכז פרטי לאבחון רפואי מהיר</a>
            <a href="/cal/assets/תקציר כתב השירות - רפואה אישית on-line.pdf" target="blank">תקציר כתב השירות - רפואה אישית on-line</a>
            <a href="/cal/assets/תקציר כתב השירות - שירותי רפואה משלימה (אלטרנטיבית).pdf" target="blank">תקציר כתב השירות - שירותי רפואה משלימה (אלטרנטיבית)</a>
          </div>
          <span>
            * הנחת יחיד 20% שנה א', 10% שנה ב'.  הנחה לשני מבוטחים ומעלה 20% ל3 שנים. <br />
            *בכפוף להצהרת בריאות וחיתום רפואי ומקצועי ואישור של חברת הביטוח. <br />
            **ט.ל.ח - ייתכנו טעויות ושינויים ויש לוודא את המחיר בשיחה טלפונית.
          </span>
        </div>
      </div>
    </div>
  );
};

export default App;
